import { Cog } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { AutoCandidate } from "@opus-dt/shared-types";
import { paramType } from "@/features/simulations/sandbox/param-types";
import { InfluenceBar } from "./charts/InfluenceBar";

interface EngineChangedListProps {
  winner: AutoCandidate | null;
}

// "o que o motor alterou": parâmetro por máquina + Δ% + etiqueta premissa.
// A influência saiu do texto miúdo e virou barra: em texto, descobrir se o motor mexeu
// onde importava exigia comparar números de linhas diferentes.
export function EngineChangedList({ winner }: EngineChangedListProps) {
  if (!winner || winner.changes.length === 0) return null;
  return (
    <Card>
      <CardHeader>
        <CardTitle>O que o motor alterou</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {winner.changes.map((c, i) => (
          <div
            key={`${c.machineId}-${c.param}-${i}`}
            className="flex items-center justify-between gap-3 border-b border-border pb-2 last:border-0"
          >
            <div className="flex items-center gap-2">
              <span className="rounded-md bg-muted p-1.5">
                <Cog className="h-4 w-4" />
              </span>
              <div>
                <p className="flex items-center gap-2 text-sm font-medium">
                  {c.machineName}
                  {c.assumed ? (
                    <span className="rounded bg-amber-100 px-1.5 text-[10px] font-medium text-amber-700">
                      premissa
                    </span>
                  ) : null}
                </p>
                <p className="text-xs text-muted-foreground">{paramType(c.param).label}</p>
                <InfluenceBar pct={c.influencePct} />
              </div>
            </div>
            <span
              className={cn(
                "font-mono text-sm tabular-nums",
                c.deltaPct > 0
                  ? "text-emerald-600"
                  : c.deltaPct < 0
                    ? "text-sky-600"
                    : "text-muted-foreground"
              )}
            >
              {c.deltaPct > 0 ? "+" : ""}
              {c.deltaPct.toFixed(0)}%
            </span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
